var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-element" }, [
    _c("div", {
      staticClass: "quote",
      domProps: { innerHTML: _vm._s(_vm.description) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }